import { useState } from "react"

import { ProductGroup } from "./ProductGroupAccordion"
import { ProductManufacturerItem } from "api/ProductManufacturers"
import { ProductGroupItem } from "api/ProductGroup"

interface FilterMobileDialogProps {
    open: boolean
    onClose: () => void
    productGroup: ProductGroup[]
    manufacturers: ProductManufacturerItem[]
    groups: ProductGroupItem[]
    selectedCategory: string | null
    selectedManufacturer: number | null
    selectedGroup: number | null
    onSelectCategory: (slug: string | null) => void
    onSelectManufacturer: (id: number | null) => void
    onSelectGroup: (id: number | null) => void
}

export default function FilterMobileDialog({
    open,
    onClose,
    productGroup,
    manufacturers,
    groups,
    selectedCategory,
    selectedManufacturer,
    selectedGroup,
    onSelectCategory,
    onSelectManufacturer,
    onSelectGroup
}: FilterMobileDialogProps) {
    if (!open) return null

    return (
        <div
            role="presentation"
            className="MuiDialog-root styles_filterMobile__hQiih"
            style={{ position: "fixed", zIndex: 1300, inset: 0, height: "100vh" }}
        >
            <div
                className="MuiBackdrop-root"
                aria-hidden="true"
                onClick={onClose}
                style={{
                    opacity: 1,
                    transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
                }}
            />

            <div tabIndex={0} data-test="sentinelStart" />

            <div
                className="MuiDialog-container MuiDialog-scrollBody"
                role="none presentation"
                tabIndex={-1}
                style={{
                    transform: "none",
                    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1)",
                }}
            >
                <div
                    className="MuiPaper-root MuiDialog-paper MuiDialog-paperScrollBody MuiDialog-paperWidthMd MuiDialog-paperFullScreen MuiDialog-paperFullWidth MuiPaper-elevation24 MuiPaper-rounded"
                    role="dialog"
                    aria-labelledby="customized-dialog-title"
                >
                    {/* HEADER */}
                    <div
                        className="MuiDialogTitle-root styles_root__HOA5n"
                        id="customized-dialog-title"
                    >
                        <button
                            className="MuiButtonBase-root MuiIconButton-root styles_closeButton__Q610w"
                            type="button"
                            aria-label="close"
                            onClick={onClose}
                        >
                            <span className="MuiIconButton-label">
                                <svg
                                    className="MuiSvgIcon-root"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                            <span className="MuiTouchRipple-root" />
                        </button>

                        <h6 className="MuiTypography-root styles_title__Oprqw MuiTypography-h6">
                            Bộ lọc tìm kiếm
                        </h6>
                    </div>

                    {/* CONTENT */}
                    <div className="MuiDialogContent-root jss25 styles_dialogContent__rXjIW MuiDialogContent-dividers">
                        <div className="MuiAccordionDetails-root styles_accordionDetail__qoKEV">
                            <div>
                                <div className="styles_group__KLzfg">
                                    <div>
                                        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
                                            <button className="styles_accordionHeader__xUFrY">
                                                <p>Nhóm sản phẩm</p>
                                                {/* <span className="styles_buttonExpanded__jSTHs styles_buttonExpand__QQLBp">
                                                    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                                                        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
                                                    </svg>
                                                </span> */}
                                            </button>

                                            <div className="MuiCollapse-root MuiCollapse-entered" style={{ minHeight: 0 }}>
                                                <div className="MuiCollapse-wrapper">
                                                    <div className="MuiCollapse-wrapperInner">
                                                        <div role="region">
                                                            <div className="styles_wrapper__pC8HE">
                                                                <div className="styles_containerList__xa02o">
                                                                    {productGroup.map(group => {
                                                                        const isActive = selectedCategory === group.id;
                                                                        return (
                                                                            <div key={group.id} onClick={() => onSelectCategory(isActive ? null : group.id)}>
                                                                                <div className={["styles_item__nZbeR", isActive && "styles_activeItem__nZbeR"].filter(Boolean).join(" ")}>
                                                                                    <div className="styles_wrapperContent__Rvdm2">
                                                                                        <span>{group.label}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>

                                                            <div className="MuiAccordionDetails-root accordion-detail" style={{ display: "block" }}>
                                                                <div className="MuiFormGroup-root" style={{ flexFlow: "column" }} />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* NHÓM THUỐC */}
                                    <div className="mt-[16px]">
                                        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
                                            <button className="styles_accordionHeader__xUFrY">
                                                <p>Nhóm thuốc</p>
                                            </button>

                                            <div className="MuiAccordionDetails-root accordion-detail" style={{ display: "block" }}>
                                                <div className="MuiFormGroup-root" style={{ flexFlow: "column" }}>
                                                    {groups.map((item) => {
                                                        const checked = selectedGroup === item.id
                                                        return (
                                                            <div key={item.id}>
                                                                <div
                                                                    className="MuiBox-root css-0"
                                                                    style={{ display: "flex", alignItems: "center" }}
                                                                    onClick={() => onSelectGroup(checked ? null : item.id)}
                                                                >
                                                                    <span
                                                                        className={
                                                                            "MuiButtonBase-root MuiIconButton-root jss9 MuiRadio-root MuiRadio-colorSecondary sc-1c0b2d97-0 jruYnQ filter-product-radio MuiIconButton-colorSecondary" +
                                                                            (checked ? " Mui-checked" : "")
                                                                        }
                                                                        aria-disabled="false"
                                                                    >
                                                                        <span className="MuiIconButton-label">
                                                                            <input
                                                                                className="jss12"
                                                                                type="radio"
                                                                                checked={checked}
                                                                                onChange={() => onSelectGroup(checked ? null : item.id)}
                                                                            />
                                                                            <div className="jss26">
                                                                                <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                                                                </svg>
                                                                                {checked && (
                                                                                    <svg className="MuiSvgIcon-root jss27" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                                                        <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z" />
                                                                                    </svg>
                                                                                )}
                                                                            </div>
                                                                        </span>
                                                                        <span className="MuiTouchRipple-root" />
                                                                    </span>
                                                                    <span className="styles_radioLabel__Ti0k5" style={{ fontWeight: "initial" }}>
                                                                        {item.name}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* NHÀ SẢN XUẤT */}
                                    <div className="mt-[16px]">
                                        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
                                            <button className="styles_accordionHeader__xUFrY">
                                                <p>Nhà sản xuất</p>
                                            </button>

                                            <div className="MuiAccordionDetails-root accordion-detail" style={{ display: "block" }}>
                                                <div className="MuiFormGroup-root" style={{ flexFlow: "column" }}>
                                                    {manufacturers.map((item) => {
                                                        const checked = selectedManufacturer === item.id
                                                        return (
                                                            <div key={item.id}>
                                                                <div
                                                                    className="MuiBox-root css-0"
                                                                    style={{ display: "flex", alignItems: "center" }}
                                                                    onClick={() => onSelectManufacturer(checked ? null : item.id)}
                                                                >
                                                                    <span
                                                                        className={
                                                                            "MuiButtonBase-root MuiIconButton-root jss9 MuiRadio-root MuiRadio-colorSecondary sc-1c0b2d97-0 jruYnQ filter-product-radio MuiIconButton-colorSecondary" +
                                                                            (checked ? " Mui-checked" : "")
                                                                        }
                                                                        aria-disabled="false"
                                                                    >
                                                                        <span className="MuiIconButton-label">
                                                                            <input
                                                                                className="jss12"
                                                                                type="radio"
                                                                                checked={checked}
                                                                                onChange={() => onSelectManufacturer(checked ? null : item.id)}
                                                                            />
                                                                            <div className="jss26">
                                                                                <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                                                                </svg>
                                                                                {checked && (
                                                                                    <svg className="MuiSvgIcon-root jss27" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                                                        <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z" />
                                                                                    </svg>
                                                                                )}
                                                                            </div>
                                                                        </span>
                                                                        <span className="MuiTouchRipple-root" />
                                                                    </span>
                                                                    <span className="styles_radioLabel__Ti0k5" style={{ fontWeight: "initial" }}>
                                                                        {item.name}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ACTIONS */}
                    <div className="MuiDialogActions-root styles_dialogActions__bEqxu MuiDialogActions-spacing">
                        <button
                            className="MuiButtonBase-root MuiFab-root styles_clearButton__Ax6om MuiFab-extended"
                            type="button"
                            aria-label="clear"
                        >
                            <span className="MuiFab-label">Xóa bộ lọc</span>
                            <span className="MuiTouchRipple-root" />
                        </button>

                        <button
                            className="MuiButtonBase-root MuiFab-root styles_close__N9S7i MuiFab-extended"
                            type="button"
                            aria-label="all"
                        >
                            <span className="MuiFab-label" onClick={onClose}>Áp dụng</span>
                            <span className="MuiTouchRipple-root" />
                        </button>
                    </div>
                </div>
            </div>

            <div tabIndex={0} data-test="sentinelEnd" />
        </div>
    )
}
